// Runtime config — values injected at container start (docker/40-runtime-config.sh
// writes /config.js from env vars; public/index.html loads it before the bundle).
// Precedence: runtime config.js > build-time REACT_APP_* > hardcoded default.
// This is what lets one Docker image promote dev→qa→uat→prod with only env
// vars differing per environment.

export type AppConfig = {
  apiBase?: string;
  // Gateway access key (`len-digitalmarketingroadmap-api-key`, per Farhan's
  // 2026-08-07 handover) — required once apiBase points at the API Gateway
  // instead of the backend's direct host. The direct host ignores it.
  apiKey?: string;
  auth?: {
    enabled?: boolean;
    // Optional overrides — defaults live in auth.ts (single app registration
    // shared by all envs today).
    clientId?: string;
    tenantId?: string;
    scope?: string;
  };
};

declare global {
  interface Window {
    __APP_CONFIG__?: AppConfig;
  }
}

const runtime: AppConfig =
  (typeof window !== "undefined" && window.__APP_CONFIG__) || {};

export const API_BASE: string =
  runtime.apiBase || process.env.REACT_APP_API_BASE || "/api";

export const API_KEY: string | undefined =
  runtime.apiKey || process.env.REACT_APP_API_KEY || undefined;

export const AUTH_ENABLED: boolean =
  runtime.auth?.enabled ?? process.env.REACT_APP_AUTH_ENABLED === "true";

export const AUTH_OVERRIDES: NonNullable<AppConfig["auth"]> = runtime.auth ?? {};
